type Scope = 'api' | 'ws' | 'demo' | 'app';

const VERBOSE =
  import.meta.env.DEV ||
  (typeof localStorage !== 'undefined' && localStorage.getItem('debug') === '1');

const COLORS: Record<Scope, string> = {
  api: '#e0a247',
  ws: '#4ea87a',
  demo: '#8d8b87',
  app: '#b4b1ab',
};

function stamp(scope: Scope): [string, string] {
  return [`%c[${scope}]`, `color:${COLORS[scope]};font-weight:600`];
}

function emit(
  method: 'log' | 'warn' | 'error',
  scope: Scope,
  message: string,
  detail?: unknown,
): void {
  const [fmt, style] = stamp(scope);
  if (detail === undefined) console[method](`${fmt} ${message}`, style);
  else console[method](`${fmt} ${message}`, style, detail);
}

export const log = {
  info(scope: Scope, message: string, detail?: unknown): void {
    emit('log', scope, message, detail);
  },
  debug(scope: Scope, message: string, detail?: unknown): void {
    if (!VERBOSE) return;
    emit('log', scope, message, detail);
  },
  warn(scope: Scope, message: string, detail?: unknown): void {
    emit('warn', scope, message, detail);
  },
  error(scope: Scope, message: string, detail?: unknown): void {
    emit('error', scope, message, detail);
  },
};
